module.exports = __webpack_public_path__ + "assets/favicon-4734e700156b02daebc504ae316baa9e.svg";